<template>
  <div>
    <div class="collaut-container" :class="borderColor">
      <slot />
      <div v-if="showBottomSection" class="border-top">
        <div class="mt-2">
          <slot name="container_bottom" />
        </div>
      </div>
    </div>

    <div v-if="showEdition" class="collaut-edition">
      <div class="collaout-edition-body">
        <slot name="edition" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomCallout',
  meta: {
    description: 'Componente común para ser usado como contenedor.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    showEdition: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Permite mostrar contenido para editar.',
        example: 'true',
      },
    },
    showBottomSection: {
      type: Boolean,
      default: () => false,
    },
    borderColor: {
      type: String,
      default: '',
      meta: {
        description:
          'Indica el color del borde izquierdo. Enumeración en import { Colors } from "@/components/common"',
        example: 'Colors.GREEN',
      },
    },
  },
};
</script>

<style scoped>
.collaut-container {
  padding: 20px 15px;
  background-color: #f7f7f7;
  border-left: 3px solid #e8e8e8;
  border-radius: 5px;
}
.collaut-edition {
  margin: 0 1px 1px 1px;
  background-color: #f7f7f7;
  border-radius: 0px 0px 5px 5px;
  padding: 5px 5px 10px 5px;
}
.collaout-edition-body {
  background-color: #ffffff;
  border-radius: 4px;
  padding: 5px;
}
.collaut-container.green {
  border-left: 3px solid #a4e5b2;
}
.collaut-container.brown {
  border-left: 3px solid #d5b89a;
}
.collaut-container.yellow {
  border-left: 3px solid #f8ea80;
}
.collaut-container.pink {
  border-left: 3px solid #fcc9c8;
}
.collaut-container.violet {
  border-left: 3px solid #ddb3d7;
}
.collaut-container.cream {
  border-left: 3px solid #f8ca80;
}
</style>
